export const glossary = {
  english: {
    glossaryLabel: 'Glossary',
    wordLabel: 'Word',
    definitionLabel: 'Definition',
    commentaryLabel: 'Commentary',
    commentaryDetail:
      'Provides an open interpretive contextualization of the message contained in the Banis (Compositions) for our current times.',
    etymologyLabel: 'Etymology',
    etymologyDetail:
      'Provides different forms of the words and their possible meanings in the respective languages.',
    footnotesLabel: 'Footnotes',
    footnotesDetail:
      'Provides additional information regarding the tagged text in general or a specific term being discussed.',
    grammarLabel: 'Grammar',
    grammarDetail:
      'Within the “Word-Meaning” section, it lists all the grammatical aspects/functions of a word in the text.',
    interpretiveLabel: 'Interpretive Transcreation',
    interpretiveDetail:
      'Provides an interpretive explanation of the original text from the Guru Granth Sahib in modern Panjabi and English.',
    introductionLabel: 'Introduction',
    introductionDetail:
      'Provides an overview of the message contained in the Banis (Compositions).',
    literalLabel: 'Literal Translation',
    literalDetail:
      'Provides the literal translation of the original text from the Guru Granth Sahib in which all words, meanings, and contexts available in the source text have been retained.',
    meaningLabel: 'Meaning',
    meaningDetail:
      'Within the “Word Meaning” section, it lists all possible sets of literal meanings and the implied meaning of a word.',
    noteLabel: 'Note',
    noteDetail:
      'Provides a summary, clarification, or explanation (where necessary) of the message.',
    poeticLabel: 'Poetical Dimension',
    poeticDetail:
      'Provides poetic aspects of the Banis (Compositions) through the utilization of known standards of poetics as well as a brief overview of figures of speech, poetic forms, and the elements of stylistics.',
  },
  panjabi: {
    glossaryLabel: 'ਸ਼ਬਦਾਂ ਦੀ ਸੂਚੀ',
    wordLabel: 'ਪਦ',
    definitionLabel: 'ਪਰਿਭਾਸ਼ਾ',
    commentaryLabel: 'ਸ਼ਾਬਦਕ ਅਨੁਵਾਦ',
    commentaryDetail:
      'ਇਹ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਦੇ ਮੂਲ ਪਾਠ ਦਾ ਸ਼ਾਬਦਕ ਅਨੁਵਾਦ ਪ੍ਰਦਾਨ ਕਰਦਾ ਹੈ, ਜਿਸ ਵਿਚ ਪਾਠ ਦੇ ਸਾਰੇ ਸ਼ਬਦ, ਅਰਥ ਅਤੇ ਪ੍ਰਸੰਗ ਬਰਕਰਾਰ ਰਖੇ ਗਏ ਹਨ।',
    etymologyLabel: 'ਕਾਵਿਕ ਪਖ',
    etymologyDetail:
      'ਕਾਵਿਕ ਪਖ ਕਾਵਿ ਸ਼ਾਸ਼ਤਰੀ ਨੇਮਾਂ ਦੀ ਵਰਤੋਂ ਦੁਆਰਾ ਬਾਣੀ ਦੇ ਕਾਵਿਕ ਪਖਾਂ ਬਾਰੇ ਚਰਚਾ ਦੇ ਨਾਲ-ਨਾਲ ਬਾਣੀਆਂ (ਰਚਨਾਵਾਂ) ਵਿਚ ਵਰਤੇ ਗਏ ਅਲੰਕਾਰਾਂ, ਕਾਵਿ-ਰੂਪਾਂ ਅਤੇ ਸ਼ੈਲੀ-ਵਿਗਿਆਨ ਦੇ ਤੱਤਾਂ ‘ਤੇ ਸੰਖੇਪ ਝਾਤ ਪਵਾਉਂਦਾ ਹੈ।',
    footnotesLabel: 'ਜਾਣ-ਪਛਾਣ',
    footnotesDetail: 'ਇਸ ਵਿਚ ਬਾਣੀਆਂ (ਰਚਨਾਵਾਂ) ਬਾਰੇ ਸੰਖੇਪ ਜਾਣਕਾਰੀ ਦਿਤੀ ਗਈ ਹੈ।',
    grammarLabel: 'ਨੋਟ',
    grammarDetail:
      'ਨੋਟ ਸੰਦੇਸ਼ ਦਾ ਸਾਰ, ਸਪਸ਼ਟੀਕਰਨ ਜਾਂ ਵਿਆਖਿਆ (ਜਿਥੇ ਜ਼ਰੂਰੀ ਹੋਵੇ) ਪ੍ਰਦਾਨ ਕਰਦਾ ਹੈ।',
    interpretiveLabel: 'ਪਦ ਅਰਥ',
    interpretiveDetail:
      '“ਪਦ ਅਰਥ” ਭਾਗ ਹੇਠ, ਇਹ ਸ਼ਬਦ ਦੇ ਸ਼ਾਬਦਕ ਅਰਥਾਂ ਅਤੇ ਭਾਵ-ਅਰਥਾਂ ਦੇ ਸਾਰੇ ਸੰਭਾਵਤ ਸਮੂਹਾਂ ਦੀ ਸੂਚਨਾ ਦਿੰਦਾ ਹੈ।',
    introductionLabel: 'ਪੈਰ ਟਿਪਣੀਆਂ	',
    introductionDetail:
      "ਪੈਰ ਟਿਪਣੀਆਂ ਆਮ ਤੌਰ 'ਤੇ ਸੰਬੰਧਤ ਪਾਠ ਜਾਂ ਖਾਸ ਤੌਰ ‘ਤੇ ਵਿਚਾਰੇ ਜਾ ਰਹੇ ਸ਼ਬਦ ਬਾਰੇ ਵਧੀਕ ਜਾਣਕਾਰੀ ਪ੍ਰਦਾਨ ਕਰਦੀਆਂ ਹਨ।",
    literalLabel: 'ਭਾਵਾਰਥਕ-ਸਿਰਜਣਾਤਮਕ ਅਨੁਵਾਦ	',
    literalDetail:
      'ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਦੇ ਮੂਲ ਪਾਠ ਦਾ ਪੰਜਾਬੀ ਅਤੇ ਅੰਗਰੇਜੀ ਦੇ ਆਧੁਨਿਕ ਰੂਪ ਵਿਚ ਭਾਵਾਰਥਕ-ਸਿਰਜਣਾਤਮਕ ਅਨੁਵਾਦ ਪ੍ਰਦਾਨ ਕਰਦਾ ਹੈ।',
    meaningLabel: 'ਵਿਉਤਪਤੀ',
    meaningDetail:
      'ਇਸ ਅਧੀਨ ਇਕ ਸ਼ਬਦ ਦੇ ਵਖ-ਵਖ ਭਾਸ਼ਾਵਾਂ ਵਿਚ ਮਿਲਦੇ ਰੂਪਾਂ ਅਤੇ ਉਨ੍ਹਾਂ ਦੇ ਸੰਭਾਵਤ ਅਰਥਾਂ ਦੀ ਸੂਚੀ ਦਿਤੀ ਗਈ ਹੈ।',
    noteLabel: 'ਵਿਆਕਰਣ',
    noteDetail:
      '“ਪਦ ਅਰਥ” ਭਾਗ ਦੇ ਅੰਤਰਗਤ ਹੀ ਇਹ ਪਾਠ ਦੇ ਵਿਆਕਰਣ ਪਖਾਂ ਦੀ ਜਾਣਕਾਰੀ ਪ੍ਰਦਾਨ ਕਰਦੀ ਹੈ।',
    poeticLabel: 'ਵਿਆਖਿਆ (ਕੁਮੈਂਟਰੀ)',
    poeticDetail:
      'ਇਹ ਬਾਣੀਆਂ (ਰਚਨਾਵਾਂ) ਵਿਚਲੇ ਸੰਦੇਸ਼ ਦਾ ਅਜੋਕੇ ਸਮੇਂ ਲਈ ਖੁਲ੍ਹਾ ਵਿਆਖਿਆਤਮਕ ਪ੍ਰਸੰਗ ਪ੍ਰਦਾਨ ਕਰਦੀ ਹੈ।',
  },
};
